export default "__VITE_ASSET__a159080d__"